import styled from "styled-components/macro";

export const StyledContainer = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  display: flex;
  align-items: center;
  background: var(--grey-3);

  div {
    text-align: center;
    width: 100%;
    h1 {
      line-height: 20px;
      text-align: center;
      font-size: 17px;
      color: var(--grey-1);
      margin-bottom: 10px;
    }
    p {
      text-align: center;
      font-size: 15px;
      color: var(--grey-1);
    }
  }
`;
